import {BodyText, FirstLabelTitle, LabelTitle, MetaDataGrid, ProjectName} from '../Style/AutoProjectStatusPageMetaData.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {Grid} from '../../../ui-library';
import React from 'react';
import {IPropsView} from '../Config/AutoProjectStatusPageMetaData.types';


const AutoProjectStatusPageMetaDataView = ({autoProjectState}: IPropsView) => (
    <>
        <FirstLabelTitle>{_SYSTEM_TITLES.autoProjectConfirmationNameTitle}</FirstLabelTitle>
        <ProjectName>{autoProjectState.projectName}</ProjectName>
        <MetaDataGrid container>
            <Grid xs={2} item>
                <LabelTitle> {_SYSTEM_TITLES.autoProjectStatusPageStartedLabel} </LabelTitle>
                <BodyText>{autoProjectState.startedDate}</BodyText>
            </Grid>
            <Grid xs={10} item>
                {autoProjectState.projectDescription &&
                    <>
                        <LabelTitle> {_SYSTEM_TITLES.autoProjectStatusPageDescriptionLabel} </LabelTitle>
                        <BodyText> {autoProjectState.projectDescription}</BodyText>
                    </>}
            </Grid>
        </MetaDataGrid>
    </>
);

export default AutoProjectStatusPageMetaDataView;
